import Layout from "../components/Layout";
import { Cookie } from "lucide-react";

const SECTIONS = [
  {
    title: "Qué son las cookies",
    paragraphs: [
      "Relevo utiliza cookies y tecnologías similares para permitir el funcionamiento de la plataforma, recordar determinadas preferencias y, cuando el usuario lo autorice, analizar el uso del servicio.",
    ],
  },
  {
    title: "Cookies necesarias",
    paragraphs: [
      "Son aquellas imprescindibles para que la plataforma funcione correctamente, por ejemplo para mantener sesiones, gestionar autenticación, seguridad o recordar las preferencias de privacidad.",
      "Estas cookies no requieren consentimiento cuando resultan estrictamente necesarias para prestar el servicio solicitado.",
    ],
  },
  {
    title: "Cookies de preferencias",
    paragraphs: [
      "Permiten recordar determinadas configuraciones elegidas por el usuario.",
      "Cuando legalmente requieran consentimiento, únicamente se utilizarán después de obtenerlo.",
    ],
  },
  {
    title: "Cookies analíticas",
    paragraphs: [
      "Permiten conocer de forma agregada cómo se utiliza Relevo y mejorar su funcionamiento.",
      "Cuando requieran consentimiento, permanecerán desactivadas hasta que el usuario las acepte.",
    ],
  },
  {
    title: "Cookies publicitarias",
    paragraphs: [
      "Si Relevo utilizase en el futuro tecnologías destinadas a medir campañas, crear perfiles o personalizar publicidad, únicamente se activarían con consentimiento previo cuando este resulte exigible.",
    ],
  },
  {
    title: "Cookies de terceros",
    paragraphs: [
      "Cuando se utilicen servicios de terceros, estos podrán instalar o acceder a cookies conforme a la configuración autorizada por el usuario.",
    ],
  },
];

export default function CookiesPolicy() {
  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-6 lg:px-10 py-12 lg:py-20" data-testid="cookies-policy-page">
        <div className="mb-12 fade-up">
          <span className="font-mono-label text-gold flex items-center gap-2">
            <Cookie className="w-3 h-3" /> Legal · Cookies
          </span>
          <h1 className="font-serif-display text-4xl md:text-5xl leading-tight mt-3">Política de Cookies</h1>
          <p className="text-muted-foreground mt-4 max-w-2xl">
            Información sobre las cookies y tecnologías similares que utiliza la plataforma Relevo, operada por Ariza Santiago Wealth Solutions, S.L.
          </p>
        </div>

        <div className="hairline bg-card">
          {SECTIONS.map((s, i) => (
            <section key={i} className={`grid md:grid-cols-12 gap-4 px-6 md:px-8 py-7 ${i > 0 ? "hairline-t" : ""}`} data-testid={`cookies-section-${i + 1}`}>
              <div className="md:col-span-4">
                <span className="font-mono-label text-[#E0712C]">{String(i + 1).padStart(2, "0")}</span>
                <h2 className="font-serif-display text-xl leading-tight mt-1">{s.title}</h2>
              </div>
              <div className="md:col-span-8 space-y-3">
                {s.paragraphs.map((t, j) => (
                  <p key={j} className="text-sm md:text-base text-muted-foreground leading-relaxed">{t}</p>
                ))}
              </div>
            </section>
          ))}
        </div>

        <p className="font-mono-label text-muted-foreground mt-8">Última actualización: junio de 2026</p>
      </div>
    </Layout>
  );
}
